import { getFormById } from "@toolkit/Framework/Store/Toolkit/Components/Form/FormSelectors";
import { BaseFormHandlerParameter } from "@toolkit/Framework/Store/Toolkit/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface SetFormHandlerParameter extends BaseFormHandlerParameter {}

type HandlerType = Handler<SetFormHandlerParameter>;

export const DispatchSetForm: HandlerType = props => {
    const formExist = getFormById(props.getState(), props.parameter.formId);

    if (!formExist) {
        props.dispatch({
            type: "Toolkit/Components/Form/SetForm",
            parameter: props.parameter,
        });
    }
};

export const chain = [DispatchSetForm];

const setForm = createHandlerChainRunner(chain, "SetForm");

export default setForm;
